<template>
    <div>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
        <video id='video' ref="videoElement" autoplay playsinline webkit-playsinline></video>
        <div class="text-container" width=100% height="auto" >
          <!-- <div id="age-status" style="font-size: 14px;"><div class = "inline">Age Estimation in Process:</div> -->
          <!-- <div class = "inline" id="process-anim"></div>  -->
          <!-- </div> -->
          <div id="estimated_age" class="inline" style="font-size: 14px;background:rgba(45, 44, 44, 0.25);">Estimated age: - </div>
          <br>
          <div id="age_label" class="inline" style="font-size: 14px;color: rgb(28, 206, 28);background:rgba(45, 44, 44, 0.25);">Age Label: - </div>
          <br>
          <div id="lighting" class="inline" style="font-size: 12px;background:rgba(45, 44, 44, 0.25)">Lighting: - </div>
          <br>
          <div id="blur" class="inline" style="font-size: 12px;background:rgba(45, 44, 44, 0.25)">Blur: -</div>
          <br>
          <div id="head_tilt" class="inline" style="font-size: 12px;background:rgba(45, 44, 44, 0.25)">Head_tilt: -</div>
          <br>
          <div id="head_left_right" class="inline" style="font-size: 12px;background:rgba(45, 44, 44, 0.25)">Head_left_right: -</div>
          <br>
          <div id="head_up_down" class="inline" style="font-size: 12px;background:rgba(45, 44, 44, 0.25)">Head_up_down: -</div>
        </div>
    </div>
    
</template>

<script>

// import { ref } from 'vue';
import * as THREE from "three";
// import * from "es-module-shims";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { FilesetResolver, FaceLandmarker } from "@mediapipe/tasks-vision";
import axios from "axios";
  
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;

// Returns the world-space dimensions of the viewport at `depth` units away from the camera.
function getViewportSizeAtDepth(camera, depth) {
  // ... (rest of the function)
  const viewportHeightAtDepth = 2 * depth * Math.tan(THREE.MathUtils.degToRad(0.5 * camera.fov));
  const viewportWidthAtDepth = viewportHeightAtDepth * camera.aspect;
  return new THREE.Vector2(viewportWidthAtDepth, viewportHeightAtDepth);
}

// Creates a `THREE.Mesh` which fully covers the `camera` viewport, is `depth` units away from the camera and uses `material`.
function createCameraPlaneMesh(camera, depth, material) {
  if (camera.near > depth || depth > camera.far) {
        console.warn("Camera plane geometry will be clipped by the `camera`!");
    }
    const viewportSize = getViewportSizeAtDepth(camera, depth);
    const cameraPlaneGeometry = new THREE.PlaneGeometry(viewportSize.width, viewportSize.height);
    cameraPlaneGeometry.translate(0, 0, -depth);
    return new THREE.Mesh(cameraPlaneGeometry, material);
}

class BasicScene {
  // ... (rest of the class)
  constructor() {
        this.lastTime = 0;
        this.callbacks = [];
        // Initialize the canvas with the same aspect ratio as the video input
        this.height = window.innerHeight;
        this.width = window.innerWidth;
        // this.width = (this.height * 1280) / 720;
        // Set up the Three.js scene, camera, and renderer
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(60, this.width / this.height, 0.01, 5000);
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setSize(this.width, this.height);
        THREE.ColorManagement.legacy = false;
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        document.body.appendChild(this.renderer.domElement);
        // Set up the basic lighting for the scene
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
        directionalLight.position.set(0, 1, 0);
        this.scene.add(directionalLight);
        // Set up the camera position and controls
        // this.camera.position.z = 100;
        this.camera.position.set(0,0,0);
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        let orbitTarget = this.camera.position.clone();
        orbitTarget.z -= 10;
        this.controls.target = orbitTarget;
        this.controls.update();
        // Add a video background
        const video = document.getElementById("video");
        const inputFrameTexture = new THREE.VideoTexture(video);
        if (!inputFrameTexture) {
            throw new Error("Failed to get the 'input_frame' texture!");
        }
        inputFrameTexture.encoding = THREE.sRGBEncoding;
        const inputFramesDepth = 1280;
        const inputFramesPlane = createCameraPlaneMesh(this.camera, inputFramesDepth, new THREE.MeshBasicMaterial({ map: inputFrameTexture }));
        this.scene.add(inputFramesPlane);
        // Render the scene
        this.render();
        window.addEventListener("resize", this.resize.bind(this));
    }
    resize() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.width, this.height);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        this.renderer.render(this.scene, this.camera);
    }
    render(time = this.lastTime) {
        const delta = (time - this.lastTime) / 1000;
        this.lastTime = time;
        // Call all registered callbacks with deltaTime parameter
        for (const callback of this.callbacks) {
            callback(delta);
        }
        // Render the scene
        this.renderer.render(this.scene, this.camera);
        // Request next frame
        requestAnimationFrame((t) => this.render(t));
    }
}

class Avatar {
  // ... (rest of the class)
  constructor(url, scene) {
        this.loader = new GLTFLoader();
        this.morphTargetMeshes = [];
        this.url = url;
        this.scene = scene;
        this.loadModel(this.url);
    }
    loadModel(url) {
        this.url = url;
        this.loader.load(
        // URL of the model you want to load
        url, 
        // Callback when the resource is loaded
        (gltf) => {
            if (this.gltf) {
                // Reset GLTF and morphTargetMeshes if a previous model was loaded.
                console.log("Remove previous model.")
                this.gltf.scene.remove();
                this.scene.remove(this.gltf.scene);
                this.morphTargetMeshes = [];
            }
            this.gltf = gltf;
            console.log();
            this.scene.add(gltf.scene);
            this.init(gltf);
        }, 
        // Called while loading is progressing
        (progress) => console.log("Loading model...", 100.0 * (progress.loaded / progress.total), "%"), 
        // Called when loading has errors
        (error) => console.error(error));
    }
    init(gltf) {
        gltf.scene.traverse((object) => {
            // Register first bone found as the root
            if (object.isBone && !this.root) {
                this.root = object;
                console.log(object);
            }
            // Return early if no mesh is found.
            if (!object.isMesh) {
                // console.warn(`No mesh found`);
                return;
            }
            const mesh = object;
            // Reduce clipping when model is close to camera.
            mesh.frustumCulled = false;
            // Return early if mesh doesn't include morphable targets
            if (!mesh.morphTargetDictionary || !mesh.morphTargetInfluences) {
                // console.warn(`Mesh ${mesh.name} does not have morphable targets`);
                return;
            }
            this.morphTargetMeshes.push(mesh);
        });
    }
    updateBlendshapes(blendshapes) {
        for (const mesh of this.morphTargetMeshes) {
            if (!mesh.morphTargetDictionary || !mesh.morphTargetInfluences) {
                // console.warn(`Mesh ${mesh.name} does not have morphable targets`);
                continue;
            }
            for (const [name, value] of blendshapes) {
                if (!Object.keys(mesh.morphTargetDictionary).includes(name)) {
                    // console.warn(`Model morphable target ${name} not found`);
                    continue;
                }
                const idx = mesh.morphTargetDictionary[name];
                mesh.morphTargetInfluences[idx] = value;
            }
        }
    }
    /**
     * Apply a position, rotation, scale matrix to current GLTF.scene
     * @param matrix
     * @param matrixRetargetOptions
     * @returns
     */
    applyMatrix(matrix, matrixRetargetOptions) {
        const { decompose = false, scale = 1 } = matrixRetargetOptions || {};
        if (!this.gltf) {
            return;
        }
        // Three.js will update the object matrix when it render the page
        // according the object position, scale, rotation.
        // To manually set the object matrix, you have to set autoupdate to false.
        matrix.scale(new THREE.Vector3(scale, scale, scale));
        this.gltf.scene.matrixAutoUpdate = false;
        // Set new position and rotation from matrix
        this.gltf.scene.matrix.copy(matrix);
    }
    /**
     * Takes the root object in the avatar and offsets its position for retargetting.
     * @param offset
     * @param rotation
     */
    offsetRoot(offset, rotation) {
        if (this.root) {
            this.root.position.copy(offset);
            if (rotation) {
                let offsetQuat = new THREE.Quaternion().setFromEuler(new THREE.Euler(rotation.x, rotation.y, rotation.z));
                this.root.quaternion.copy(offsetQuat);
            }
        }
    }
}

function createRotationMatrixY(angleInRadians) {
  // ... (rest of the function)
}
let socket = null;
var age = 0;

function socketconnect() {
    socket = io('https://fallback-server-for-on-browser.privately.swiss:8998')
    // $socket is socket.io-client instance
    socket.on("connect", () => {
    console.log('WebSocket connection established.');
    // captureVideo();
    });
}
function socketdisconnect() {

    socket.disconnect();
    // $socket is socket.io-client instance
    socket.on("disconnect", () => {
        console.log('WebSocket disconnected.');
        // captureVideo();
        });
}
function sendtoparent(information){
    parent.postMessage(information,"*")
}



export default {
    name: "AgeAvatar",
    data() {
      return {
          loading: false,
          predictioncl: "",
          // api_url:"http://127.0.0.1:8082/",
          isCameraOpen: false,
          isLoading: false,
          video : null,
          ctx_overlay: null,
          lines: [], 
          
  
      };
    },
    
    mounted() {
        // const videoElement = ref(null);
        let prev_avatar = "./child_avatar.glb";
        let next_avatar = "./child_avatar.glb";
        const scene = new BasicScene();
        // const avatar = new Avatar("https://assets.codepen.io/9177687/raccoon_head.glb", scene.scene);
        // const imagePath = require("../../assets/3davatar/chibi_head.glb")
        let avatar = new Avatar(prev_avatar, scene.scene);
        console.log(avatar)
        let faceLandmarker;
        let video;
        let check = true;
        socketconnect();
        function updateResponse(data){
        // canvas.width = video.videoWidth;
        // canvas.height = video.videoHeight;
        // const ctx_overlay = this.$canvas_overlay.getContext("2d");

        // // Draw bounding box
        // ctx.strokeStyle = 'red';
        // ctx.lineWidth = 2;

        
        // this.drawLines(data['face_contours']);

        // ctx.fillStyle = 'blue';
        // ctx.font = '16px Arial';
        let color_yes = "rgb(28, 206, 28)";
            if ( data['estimated_age']=="Bad Env/Pose" || data['estimated_age']=='-') {
                document.getElementById("estimated_age").style.color = 'red';
            } else {
                document.getElementById("estimated_age").style.color = color_yes;
            }
            if ( data['estimated_age']=='-'){
            data['estimated_age'] = 'No face detected'
            }
            else if (data['estimated_age']>35){
            document.getElementById('estimated_age').innerText = "Estimated age: " + "35+";
            }
            else{
                document.getElementById('estimated_age').innerText = "Estimated age: " + data['estimated_age'];
            }
            if ( data['lighting'][0]=='good') {
                document.getElementById("lighting").style.color = color_yes;
            } else {
                document.getElementById("lighting").style.color = 'red';
            }
            document.getElementById("lighting").innerText = "Lighting: " + data['lighting'][0] 
            // + "(" + data['lighting'][1] + ")";

            document.getElementById("blur").innerText = "Blur: " + data['blur'][0] 
            // + "(" + data['blur'][1] + ")";

            if ( data['blur'][0]=='clear') {
                document.getElementById("blur").style.color = color_yes;
            } else {
                document.getElementById("blur").style.color = 'red';
            }

            if ( data['head_tilt'][0]=='straight') {
                document.getElementById("head_tilt").style.color = color_yes;
            } else {
                document.getElementById("head_tilt").style.color = 'red';
            }
            document.getElementById("head_tilt").innerText = "Head_tilt: "+data['head_tilt'][0] 
            // + "(" + data['head_tilt'][1] + ")";
            if ( data['head_left_right'][0]=='straight') {
                document.getElementById("head_left_right").style.color = color_yes;
                
            } else {
                document.getElementById("head_left_right").style.color = 'red';
            }
            document.getElementById("head_left_right").innerText = "Head_left_right: " + data['head_left_right'][0] 
            // + "(" + data['head_left_right'][1] + ")";

            if ( data['head_up_down'][0]=='straight') {
                document.getElementById("head_up_down").style.color =color_yes;
            } else {
                document.getElementById("head_up_down").style.color = 'red';
            }
            document.getElementById("head_up_down").innerText = "Head_up_down: " + data['head_up_down'][0] 
            // + "(" + data['head_up_down'][1] + ")";
        }
        
        function processVideoFrames() {
            const videoTrack = video.srcObject.getVideoTracks()[0];
            const imageCapture = new ImageCapture(videoTrack);

            setInterval(() => {
                imageCapture.grabFrame()
                .then(imageBitmap => {
                    // Convert imageBitmap to base64
                    const canvas = document.createElement('canvas');
                    canvas.width = imageBitmap.width;
                    canvas.height = imageBitmap.height;
                    // canvas.width = window.width;
                    // canvas.height = window.height;
                    // console.log("Width = "+window.width + "height:" + window.height)
                    const context = canvas.getContext('2d');
                    context.drawImage(imageBitmap, 0, 0);
                    const base64Data = canvas.toDataURL('image/jpeg'); // Change format as needed

                    // Send base64Data to backend API
                    // sendFrameToBackend(base64Data);
                    socket.emit('image',{'image': base64Data});
                    // requestAnimationFrame(sendFrame);
                    socket.on('image_resp', (data) => {
                    // console.log("Estimated Age: "+ data['estimated_age']);
                    updateResponse(data)
                    // sending data to parent iframe
                    age = data['estimated_age']
                    var information = {
                    estimated_age:  data['estimated_age'],
                    }});
                })
                .catch(error => {
                    console.error('Error grabbing frame: ', error);
                });

                // requestAnimationFrame();
            },200);

            // captureFrame(); // Start capturing frames
        }


        async function runDemo() {
        // console.log("Entered runDemo.");
        await streamWebcamThroughFaceLandmarker();
        const vision = await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.1.0-alpha-16/wasm");
        faceLandmarker = await FaceLandmarker.createFromModelPath(vision, "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/latest/face_landmarker.task");
        await faceLandmarker.setOptions({
            baseOptions: {
            delegate: "GPU"
            },
            runningMode: "VIDEO",
            outputFaceBlendshapes: true,
            outputFacialTransformationMatrixes: true
        });
        console.log("Finished Loading MediaPipe Model.");
        }

        function detectFaceLandmarks(time) {
        // ... (rest of the function)
        // console.log("faceLandmarker",faceLandmarker)
        video = document.getElementById("video");
        // console.log(time)
        if (!faceLandmarker) {
            return;
        }
        if (time > 10000 && age<16) {
            next_avatar = "/child_avatar.glb";
            document.getElementById('age_label').innerText = "Age Label: Child (<16)";
        }
        else if (time > 10000 && age>=16 && age<=25) {
            next_avatar = "/adolescent_avatar.glb";
            document.getElementById('age_label').innerText = "Age Label: Young adult (16-24)";
            
        }
        else if  (time > 10000 && age>25){
            next_avatar = "/adult_avatar.glb";
            document.getElementById('age_label').innerText = "Age Label: Adult (25+)";
        }

        if (prev_avatar != next_avatar){
            avatar.loadModel(next_avatar);
            prev_avatar = next_avatar
        }
        const landmarks = faceLandmarker.detectForVideo(video, time);
        // Apply transformation
        const transformationMatrices = landmarks.facialTransformationMatrixes;
        if (transformationMatrices && transformationMatrices.length > 0) {
            // console.log("Entered")
            let matrix = new THREE.Matrix4().fromArray(transformationMatrices[0].data);
            // Example of applying matrix directly to the avatar
            // console.log(matrix)
            // Adjust translation values to control movement
            
            // matrix.elements[12] *= 7; // Adjust X translation (experiment with different values)
            // matrix.elements[13] *= 2; // Adjust Y translation (experiment with different values)
            // matrix.elements[14] *= 1; // Adjust Z translation (experiment with different values)
            // avatar.scene.resize();
            avatar.applyMatrix(matrix, { scale: 15 });
        }
        // Apply Blendshapes
        const blendshapes = landmarks.faceBlendshapes;
        if (blendshapes && blendshapes.length > 0) {
            const coefsMap = retarget(blendshapes);
            avatar.updateBlendshapes(coefsMap);
        }
        }

        function retarget(blendshapes) {
        // ... (rest of the function)
        const categories = blendshapes[0].categories;
        let coefsMap = new Map();
        for (let i = 0; i < categories.length; ++i) {
            const blendshape = categories[i];
            // Adjust certain blendshape values to be less prominent.
            switch (blendshape.categoryName) {
                case "browOuterUpLeft":
                    blendshape.score *= 1.2;
                    break;
                case "browOuterUpRight":
                    blendshape.score *= 1.2;
                    break;
                case "eyeBlinkLeft":
                    blendshape.score *= 1.2;
                    break;
                case "eyeBlinkRight":
                    blendshape.score *= 1.2;
                    break;
                default:
            }
            coefsMap.set(categories[i].categoryName, categories[i].score);
        }
        return coefsMap;

        }

        function onVideoFrame(time) {
        // ... (rest of the function)
        // Do something with the frame.
        detectFaceLandmarks(time);
        // Re-register the callback to be notified about the next frame.
        video.requestVideoFrameCallback(onVideoFrame);
        }

        async function streamWebcamThroughFaceLandmarker() {
        // ... (rest of the function)
        video = document.getElementById("video");
        function onAcquiredUserMedia(stream) {
            video.srcObject = stream;
            processVideoFrames();
            video.onloadedmetadata = () => {
                video.play();
            };
        }
        try {
            const evt = await navigator.mediaDevices.getUserMedia({
                audio: false,
                video: {
                    facingMode: "user",
                    width: 1280,
                    height: 720
                }
            });
            onAcquiredUserMedia(evt);
            video.requestVideoFrameCallback(onVideoFrame);
        }
        catch (e) {
            console.error(`Failed to acquire camera feed: ${e}`);
        }
        }
        

        
        runDemo();
        // return {
        //   videoElement,
        // };
    },


    beforeUnmount() {
        // ... (rest of the beforeUnmount function)
        // socketconnect();
    },
    beforeDestroy() {
        // Remove event listener when the component is destroyed
        window.removeEventListener('resize', this.handleWindowResize);
        this.socketdisconnect();
    },
};
</script>

<style>

#video{
    /* transform: rotateY(180deg);
    -webkit-transform:rotateY(180deg); /* Safari and Chrome */
    /* -moz-transform:rotateY(180deg); */
    display:none;
    /* user-scalable: no; */

  }
canvas{
  position: absolute;
  transform: scaleX(-1);
  z-index: 0;
  top: 0;
  user-scalable: no;
}

.text-container{
    position: absolute; 
    background: transparent; 
    top: 0%; 
    right: 0%; 
    left: 0%; 
    pointer-events: none;
    z-index: 10;
    /* background:rgba(255, 255, 255, 0.25); */
    /* text-shadow: -1px -1px 0 #493a3a, 1px -1px 0 #493a3a, -1px 1px 0 #493a3a, 1px 1px 0 #493a3a; */
    letter-spacing: 1px;
    -webkit-text-stroke: 0.1px grey;
}
.inline { display: inline-block;
    height: auto;  }

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/* Your component-specific styles go here */
</style>